import CalendarCanvas from './CalendarCanvas'
import withCachedLabels from './withCachedLabels'
import withState from './withState'

const CalendarWithState = withState(CalendarCanvas)

export { CalendarCanvas, CalendarWithState }

export default withCachedLabels(CalendarWithState)
